import { Record } from 'immutable';

import trainTime from '../lib/TrainTime';
import { resolve } from '../helpers/LinkMapper';


const AdjustedTime = new Record({
    id: null,
    scheduledTime: trainTime(),
    adjustedTime: trainTime(),
    confidence: 'Uncertain',
    delayed: false
});

AdjustedTime.fromJSON = function (json) {
    json = json || {};

    const scheduledTime = resolve(json.scheduledTime).with(trainTime);
    const adjustedTime = resolve(json.adjustedTime).with(trainTime);
    const confidence = resolve(json.confidence).with(String);
    const delayed = resolve(json.delayed).with(Boolean);

    let result = { scheduledTime, adjustedTime, confidence, delayed };

    return new AdjustedTime(result);
};

export default AdjustedTime;
